import { useRequest } from '~/repositories'

/** Fetches the user's in-app notifications (ticket results) with pagination and read-status filtering. */
export const getNotifications = (params: any) => {
	return useRequest('get', `/v1/user/notifications/`, { params })
}

/** Enables or disables result notifications for a specific user lottery. */
export const postEnabledNotifications = (payload: any) => {
	return useRequest('post', `/v1/user/lottery-results-notification/`, payload)
}

/** Marks all unread notifications as read for the current user. */
export const postMarkAllAsReadNotifications = () => {
	return useRequest('post', `/v1/user/notifications/read-all/`)
}

/** Marks a single notification as read by its ID. */
export const postMarkAsReadNotification = (notificationId: number) => {
	return useRequest('post', `/v1/user/notifications/${notificationId}/read/`)
}

export default {
	getNotifications,
	postEnabledNotifications,
	postMarkAsReadNotification,
	postMarkAllAsReadNotifications,
}
